import { BotMetadata, EnvironmentType } from '@feedyou/schema'
import { RootState } from '../../../reducers'
import { botMetadataForEnvironmentGroupSelector } from './botMetadataForEnvironmentGroupSelector'

export const botMetadataForEnvironmentSelector =
  (environmentGroupId: string | null | undefined, environmentType: EnvironmentType) =>
  (state: RootState): BotMetadata | undefined => {
    const metadataForGroup = botMetadataForEnvironmentGroupSelector(environmentGroupId)(state)

    return metadataForGroup?.find(metadata => metadata.environmentType === environmentType)
  }
